import { AffectedMaterial, Color } from '../ColorValue';

export class ColorMapper {
  static toColorDomain = (dto: CoreServiceAPI.ColorDto): Color => ({
    externalId: dto.externalId,
    affectedMaterial: AffectedMaterial[dto.targetMaterial],
    possibleColorValues: dto.possibleColorValues,
    localisedName: dto.localisedName,
  });
}
